import { IUserContactPermissions, IUserPermissions } from "../../interface/IUserDetails";

interface IUserContactPermissionsResponse {
    enabled: boolean;
    name: string;
    permission: string;
}

interface IUserPermissionsResponse {
    name: string;
    permissionGroup: string;
    permissions: IUserContactPermissionsResponse[];
}

export interface IUserPermissionsGroupResponse {
    language: string;
    permissionGroupResponse: IUserPermissionsResponse[];
}

export const getResponseToState = (response: IUserPermissionsGroupResponse): IUserPermissions[] =>
    response.permissionGroupResponse.map((permission) => ({
        name: permission.name,
        permissionGroup: permission.permissionGroup,
        permissions: permission.permissions.map((contactPermission) => ({
            name: contactPermission.name,
            permission: contactPermission.permission,
            isEnabled: contactPermission.enabled,
        })),
    }));

export interface IUserContactPermissionsPayload {
    enabled: boolean;
    name: string;
    permission: string;
}

export interface IUserPermissionsPayload {
    permissionGroup: string;
    permissions: IUserContactPermissionsPayload[];
}

export const getStateToPayload = (
    permissionGroup: string,
    userContactPermissions: IUserContactPermissions[],
    language: string,
    permissionGroupName: string
): IUserPermissionsGroupResponse => ({
    language: language,
    permissionGroupResponse: [
        {
            name: permissionGroupName,
            permissionGroup: permissionGroup,
            permissions: userContactPermissions.map((userContactPermission) => ({
                name: userContactPermission.name,
                permission: userContactPermission.permission,
                enabled: userContactPermission.isEnabled,
            })),
        },
    ],
});
